import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonService } from "@app/shared/common/common.service";
import { Router } from "@angular/router";
import { ActivitiesService } from "../activities.service";

@Component({
  selector: '[activitiesNotification]',
  templateUrl: './activities-notification.component.html',
})
export class ActivitiesNotificationComponent implements OnInit {

  @Input() item: any;
  @Output() childEvent = new EventEmitter();
  navigateURL = { capture: "/invoice/accounting/edit/", assignment: "/invoice/accounting/assignment/", other: "/invoice/accounting/overview/" };
  lanId: string;

  constructor(private router: Router, private commonService: CommonService, private activitiesService: ActivitiesService) {
    this.lanId = this.commonService.getCurrentLanguageCode();
  }

  ngOnInit() {
  }

  updateReadStatus(event: any) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!this.item || this.item.viewed === '1') {
      return;
    }

    this.item.viewed = '1';
    this.item.status = 'read';

    const id = String(this.item.taskId || this.item.detId || this.item.docId || this.item.id);
    let data = new FormData();
    data.append('id', id);
    data.append('companyId', localStorage.getEncryptedItem('companyId'));
    data.append('instanceId', localStorage.getEncryptedItem('instanceId'));
    data.append('loggedInTime', localStorage.getEncryptedItem('loggedInTime'));
    data.append('lastRequestTime', localStorage.getEncryptedItem('lastRequestTime'));
    data.append('userId', localStorage.getEncryptedItem('loginId'));
    data.append('language', this.commonService.getCurrentLanguageCode());

    let object = this.commonService.createObject(data);
    let token = this.commonService.createToken(object);
    let encryptedToken = this.commonService.encrypt(token);
    let encrData = new FormData();
    encrData.append('encrToken', encryptedToken);

    this.activitiesService.updateApplicationEventReadStatus(encrData).subscribe((res: any) => {
      if (res && res.RESPONSETIME) {
        localStorage.setEncryptedItem('lastRequestTime', res.RESPONSETIME);
      }
      this.activitiesService.triggerRefresh();
    });
  }
  getInvoice(creditorId, detId, taskId) {
    this.childEvent.emit();

    let url = "";
    let open;
    let data = new FormData();
    data.append('creditorId', creditorId);
    data.append('language', this.commonService.getCurrentLanguageCode());
    data.append('userId', localStorage.getEncryptedItem('loginId'));
    data.append('companyUserId', localStorage.getEncryptedItem('companyUserId'));
    data.append("loggedInTime", localStorage.getEncryptedItem("loggedInTime"));
    data.append("lastRequestTime", localStorage.getEncryptedItem("lastRequestTime"));
    data.append('instanceId', localStorage.getEncryptedItem("instanceId"));
    data.append('companyId', localStorage.getEncryptedItem("companyId"));
    let object = this.commonService.createObject(data);
    let token = this.commonService.createToken(object);
    let encryptedToken = this.commonService.encrypt(token);
    let encrData = new FormData();
    encrData.append("encrToken", encryptedToken);
    this.activitiesService.getCurrentStep(encrData).subscribe((res: any) => {
      if (!res.status && res.isUnauthenticated) {
        this.commonService.logout();

        return false;
      }
      localStorage.setEncryptedItem("lastRequestTime", res.RESPONSETIME);
      if (res.status) {
        url = '/invoice/accountingnew/';
      }
      if (url != "")
        localStorage.setEncryptedItem("fromPage", url);
      url = url + creditorId + '/' + detId;
      this.router.navigate([url]);
    });
  }
  gotoContract(version_uid, taskUid, taskId) {
    this.childEvent.emit();

    setTimeout(() => {
      let url = '/contract/searchcontracts/searchdetail/' + version_uid + '/' + taskUid;
      this.router.navigate([url]);
    }, 1000);
  }
  goToInspectorDetail(docId, taskId) {
    this.childEvent.emit();

    setTimeout(() => {
      let url = '/purchase/inspector/' + docId;
      this.router.navigate([url]);
    }, 1000);
  }

  setClasses() {
    let classes = {
      'fa fa-fw fa-2x': true
    };
    classes[this.item.icon] = true;
    return classes;
  }

}
